module.exports = __webpack_public_path__ + "img/detatchedHouse.6c65c69b.png";